module.exports = __webpack_public_path__ + "img/900724920.f853dcc8.png";